module.exports = __webpack_public_path__ + "static/media/warning.7bb33cd7.png";